import { render, staticRenderFns } from "./FinialGroup.vue?vue&type=template&id=3e37f641&scoped=true&"
import script from "./FinialGroup.vue?vue&type=script&lang=ts&"
export * from "./FinialGroup.vue?vue&type=script&lang=ts&"
import style0 from "./FinialGroup.vue?vue&type=style&index=0&id=3e37f641&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e37f641",
  null
  
)

export default component.exports